/**
 * Builds overrides dictionary from a messages array for private mode.
 * When isPrivate is true, message content is not persisted and must be sent per request.
 * @param messages - Array of messages with optional messageId and message
 * @returns Record of messageId -> message content, or undefined if no valid entries
 */
export const buildOverridesFromMessages = (
  messages: { messageId?: string; message?: string }[] | undefined,
): Record<string, string> | undefined => {
  if (!messages || messages.length === 0) {
    return undefined;
  }
  const overrides: Record<string, string> = {};
  for (const msg of messages) {
    if (msg.messageId && msg.message) {
      overrides[msg.messageId] = msg.message;
    }
  }
  return Object.keys(overrides).length > 0 ? overrides : undefined;
};
